/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
import React from 'react'

import './StayedDetailsSection.css'

const StayedDetailsSection = ({ labels, values }) => {
  return (
    <div className="stayed-details-section">
      <h2 className="section-title">Stayed Details</h2>
      <dl className="stayed-info-container">
        {Object.keys(labels).map((key) => (
          <div key={key} className="NoticeDetailRow">
            <dt>{labels[key]}</dt>
            <dd>{values[key]}</dd>
          </div>
        ))}
      </dl>
    </div>
  )
}

export default StayedDetailsSection
